<template>
  <div :class="$style.container">
    <div :class="$style.header">
      <div>
        <span :class="$style.bold">
          您选取了
          <span class="theme-color">{{ list.length }}</span> 条单据开具发票
        </span>
        (若选中多条记录，金额将合并开具在一张票据中)
      </div>
      <div>
        <span :class="$style.bold">
          已选开票金额 : <span class="theme-color">￥{{ selectAmount }}</span>
        </span>
      </div>
    </div>

    <div :class="$style.content">
      <Item title="发票信息">
        <el-select v-model="infoId" placeholder="全部">
          <el-option
            v-for="item in infoList"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>

        <span :class="$style.add_receipt" @click="addInfo">+ 发票信息</span>
      </Item>

      <template v-if="infoId">
        <Item title="开具类型">
          <el-radio v-model="issuingType" :label="0" disabled>个人</el-radio>
          <el-radio v-model="issuingType" :label="1" disabled>企业</el-radio>
        </Item>

        <Item title="发票类型">
          <el-radio v-model="invoiceType" :label="0" disabled
            >增值税普通发票</el-radio
          >
          <el-radio v-model="invoiceType" :label="1" disabled
            >增值税专用发票</el-radio
          >
        </Item>
        <Item title="发票抬头">
          <span :class="$style.invoice_header">{{ header }} </span>
        </Item>
      </template>

      <Item title="发票内容" required>
        <el-radio v-model="contentType" :label="0">域名服务费</el-radio>
        <el-radio v-model="contentType" :label="1">信息服务费</el-radio>
      </Item>
      <Item title="收件人" required>
        <el-input v-model="consignee" />
      </Item>
      <Item title="手机号码" required>
        <el-input v-model="mobile" maxlength="11" />
      </Item>
      <Item title="收件人地址" required>
        <el-input v-model="address" placeholder="请如实填写你的收件地址" />
        <span :class="$style.desc">如：xx省xxx市xx县(区)xx路(街道)xx号</span>
      </Item>
      <Item title="邮编">
        <el-input v-model="postalCode" />
      </Item>
      <Item title="备注">
        <el-input v-model="remark" />
      </Item>
    </div>

    <div :class="$style.expressType">
      <el-radio
        v-model="expressType"
        :label="0"
        :disabled="expressFee === '' || expressType > amountInfo.balance"
      >
        快递
        <span class="theme-color">{{ expressFee }}</span> 元（当前可用余额：{{
          amountInfo.balance
        }}元）
      </el-radio>
      <el-radio v-model="expressType" :label="1">到付（顺丰）</el-radio>
    </div>

    <Row :class="$style.bottom_actions">
      <Button type="primary" @click="submitApply">提交申请</Button>
      <Button @click="stepBack(false)">返回上一步</Button>
      <el-checkbox :class="$style.select_default" v-model="isDefault">
        设置默认信息
      </el-checkbox>
    </Row>
  </div>
</template>

<script>
import { mapState } from "vuex";

import {
  getInvoiceInfoList,
  getDefaultInvoice,
  createInvoiceApply,
} from "@server";
import { validPhone } from "@utils";

export default {
  name: "ReceiptFill",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    selectAmount: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      // 填写发票所需的信息
      infoList: [],
      infoId: "", // 发票信息
      issuingType: "", // 开具类型
      invoiceType: "", // 发票类型
      header: "", // 发票抬头

      contentType: 0, // 发票内容
      consignee: "", // 收件人
      expressType: "", // 快递费支付方式 0：寄付 1：到付
      mobile: "", // 手机号码
      address: "", // 地址
      postalCode: "", // 邮编
      remark: "", // 备注
      isDefault: 0, //是否是默认 0：否 1：是
      expressFee: 0, // 快递费用
    };
  },
  computed: {
    ...mapState("user", ["amountInfo"]),
  },
  watch: {
    infoId: {
      handler(id) {
        if (!id) return;
        const info = this.infoList.find((item) => item.id === id);
        this.issuingType = info.issuingType;
        this.invoiceType = info.invoiceType;
        this.header = info.header;
      },
      immediate: true,
    },
  },
  methods: {
    //发票信息列表
    async getInvoiceInfoList() {
      const res = await getInvoiceInfoList();

      if (res.code === 200) {
        this.infoList = res.data.map((item) => {
          const { header, issuingType, type } = item;
          return {
            label: `${header} - ${issuingType == 0 ? "个人" : "类型"} - 增值税${
              type == 0 ? "普通" : "专用"
            }发票`,
            ...item,
          };
        });
      }
    },

    //获取默认发票信息
    async getDefaultInfo() {
      const res = await getDefaultInvoice();
      const { code, data } = res;

      if (code === 200 && data) {
        if (data.infoId) {
          this.infoId = data.invoiceId;
          this.contentType = data.contentType;
          this.consignee = data.recipient;
          this.mobile = data.phone;
          this.address = data.address;
          this.postalCode = data.postCode;
        }
        this.expressFee = data.expressFee;
      }
    },

    checkSubmit() {
      if (this.list.length <= 0) {
        this.$message({ message: "请选择开票订单!", type: "warning" });
        this.stepBack();
        return false;
      }
      if (!this.infoId) {
        this.$message({ message: "请输入选择发票信息!", type: "warning" });
        return false;
      }
      if (!this.consignee) {
        this.$message({ message: "请输入收件人!", type: "warning" });
        return false;
      }
      if (!validPhone(this.mobile)) {
        this.$message({
          message: `请输入${this.mobile && "正确的"}手机号码!`,
          type: "warning",
        });
        return false;
      }
      if (!this.address) {
        this.$message({ message: "请输入收件人地址!", type: "warning" });
        return false;
      }
      if (this.expressType === "") {
        this.$message({ message: "请选择支付方式!", type: "warning" });
        return false;
      }

      return true;
    },

    async submitApply() {
      if (!this.checkSubmit()) return;

      this.loading = true;
      const data = {
        idList: this.list.map((item) => item.id),
        invoiceId: this.infoId,
        header: this.header,
        contentType: this.contentType,
        recipient: this.consignee,
        phone: this.mobile,
        address: this.address,
        postCode: this.postalCode,
        remark: this.remark,
        expressType: this.expressType,
        isDefault: this.isDefault ? 1 : 0,
      };
      let res = await createInvoiceApply(data);

      if (res.code == 200) {
        this.$message({
          message: "申请提交成功，您的申请将在后台审核!",
          type: "success",
        });
        this.stepBack(true);
      }
      this.loading = false;
    },

    addInfo() {
      this.$message({ message: "敬请开放!", type: "success" });
    },

    stepBack(isUpdate = false) {
      this.$emit("stepBack", isUpdate);
    },
  },

  async created() {
    await this.getInvoiceInfoList();
    this.getDefaultInfo();
  },
};
</script>

<style lang="scss" module scoped>
.container {
  :global {
    .gl-item {
      height: rem(100);

      ::v-deep .gl-item__left {
        box-sizing: border-box;
        width: rem(230);
        height: 100%;
        padding-left: rem(60);
        border-right: $border-1;
        border-bottom: $border-1;
      }

      ::v-deep .gl-item__right {
        flex: 1;
        height: 100%;
        padding: 0 rem(50);
        border-right: $border-1;
        border-bottom: $border-1;
      }
    }

    .el-select {
      ::v-deep .el-input {
        width: rem(360);
      }
    }

    .el-input {
      width: rem(360) !important;
      margin-right: rem(30);
    }

    .el-radio {
      ::v-deep .el-radio__label {
        font-size: rem(14);
      }
    }

    .el-checkbox {
      margin-left: rem(20);
      ::v-deep .el-checkbox__input {
        .el-checkbox__inner {
          border-radius: 50%;
        }
      }

      ::v-deep .el-checkbox__label {
        padding-left: rem(20);
        font-size: rem(14);
        font-weight: bold;
        color: #333;
      }
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: rem(70);
    padding-left: rem(40);
    padding-right: rem(80);
    margin-top: rem(30);
    background-color: #f6f6f9;
    font-size: rem(14);
  }

  .content {
    border-left: $border-1;
    border-top: $border-1;

    .add_receipt {
      padding-left: 20px;
      font-size: rem(14);
      color: $theme-color;
      user-select: none;
      cursor: pointer;
    }
    .invoice_header {
      font-size: rem(14);
      color: #333;
    }

    .desc {
      padding-left: 20px;
      font-size: rem(14);
      color: $theme-color;
      letter-spacing: 1px;
    }
  }

  .bold {
    font-weight: bold;
  }

  .expressType {
    padding-left: 40px;
    height: rem(100);
    line-height: rem(100);
  }

  .bottom_actions {
    padding: rem(40) 0;
    margin-left: rem(80);
    gap: rem(30);
  }
}
</style>